import React,{Component} from "react";
import {Modal,Button} from 'react-bootstrap';
import "../scss/general.css";
import "../scss/QR.css";
import QRCode from "react-qr-code";
//import "font-awesome/css/font-awesome.min.css";
//import * as htmlToImage from "html-to-image";
//import TitleLogo from  "../component/images/Logo.png";
const vCardsJS = require( 'vcards-js');
const ref = React.createRef();
export default class VCQRcode extends Component{
    constructor(props)
    {
        super(props);
           this.state={ErrMsg2:"",VCard:"",isOpen:true,address:"K&Ns Center, 160 Banglore Town Shara-e-Faisal, Karachi. UAN: 111 564 564"};
    }
    openModal=(e)=>{this.setState({ isOpen: true }); }
    closeModal=(e)=>{this.setState({ isOpen: false });
    this.props.resetmodal();                    }
    downloadImage = async () => {

        const dataUrl = await htmlToImage.toPng(ref.current);
                           
        // download image
        const link = document.createElement('a');
        link.download = this.props.name+".png";
        link.href = dataUrl;
        link.click();
        this.downloadvcf();
                        
    }
                        
    downloadvcf =()=>{  
        // This is vCard instance, that
        // represents a single contact file
        const FileSaver = require('file-saver');
//        const blob = new Blob([ vCard.getFormattedString() ], {type: ""});
        const blob = new Blob([ this.state.VCard ], {type: ""});
        let filename=this.props.name+".vcf";
        FileSaver.saveAs(blob, filename); 
    }
                        
                    
    componentDidMount(){
        let vCard = vCardsJS();
        vCard.firstName=this.props.name;
        vCard.name = "this.props.name";
        vCard.organization = "K&N's Poultry Farms";
        vCard.title = this.props.designation;
        vCard.workEmail = this.props.email;
        vCard.cellPhone = this.props.phone ;
        vCard.workPhone=this.props.officeno;
        
//        vCard.url=this.props.URL;
        this.setState({VCard:vCard.getFormattedString()});

    }
    render(){
        return(
                <Modal  dialog ClassName="pmodal" show={this.state.isOpen} onHide={this.closeModal}  border-radius="15px" transition="all .3s"  aria-labelledby="contained-modal-title-vcenter" animation={false}  centered>               
                <Modal.Header closeButton style={{backgroundColor:"light-gray", color:"black", height:55}}>
                <Modal.Title style={{ paddingTop:5}}>vCard {/*{this.props.Title}*/}</Modal.Title>
                </Modal.Header > 
                <Modal.Body >
{/*}                <div style={{width:"105mm",marginLeft:25,backgroundColor:"#fff"}} >*/}
                <div className="div_vcard"  >
                <main style={{background: "#fff",width: "102mm", height: "50.8mm",border:"2px",borderColor:"#fff", borderRadius: "5px",boxShadow: "#9E9E9E 0px 0px 10px",padding:1.5 }}  ref={ref}>
                    <div style={{height:"46mm",background: "#fff", float:"left"}}>
                    <table  style={{width:"260px",background: "#fff",border:"none"}} >
                        <thead>
                        </thead>

                        <tbody style={{width:260,height:150,fontSize:"9pt"}}>
                            <tr  >
                                <td style={{width:12,border:"none",paddingLeft:3,paddingTop:11,}} ></td>
                                <td style={{width:125,border:"none",paddingBottom:0,paddingTop:11}}><b>{this.props.name}</b></td>
                            </tr>
                            <tr >
                                <td style={{width:12,border:"none",height:10,paddingLeft:5}} ></td>
                                <td style={{width:125,border:"none",height:10,paddingTop:0}}>{this.props.designation}</td>
                            </tr>
                            <tr>
                                <td style={{width:12,border:"none",height:25,marginTop:1}} ></td>
                                <td style={{width:125,border:"none",height:25,marginTop:1}}></td>
                            </tr>
                            
                            <tr>
                                <td style={{width:12,border:"none",textAlign:"end",paddingRight:2,paddingTop:0,paddingBottom:0}} ><i style={{paddingLeft:6,fontSize:"8pt"}} className="fa fa-phone"></i> </td>
                                <td style={{width:125,border:"none",paddingLeft:1,paddingTop:0,paddingBottom:0,fontSize:"8pt"}}>{this.props.officeno}</td>
                            </tr>
                            <tr>
                                <td style={{width:12,border:"none",textAlign:"end",paddingRight:2,paddingTop:0,paddingBottom:0}} ><i style={{paddingLeft:6,fontSize:"14pt"}} className="fa fa-mobile "/></td>
                                <td style={{width:125,border:"none",paddingLeft:1,paddingTop:0,paddingBottom:0,fontSize:"8pt"}}>{this.props.phone}</td>
                            </tr>

                            <tr >
                                <td style={{width:12,border:"none",textAlign:"end",paddingRight:2,paddingTop:0,paddingBottom:0}} ><i style={{paddingLeft:6,fontSize:"8pt"}} className="fa fa-envelope-o" /></td>
                                <td style={{width:125,border:"none",paddingLeft:1,paddingTop:0,paddingBottom:0,fontSize:"8pt"}}>{this.props.email}</td>

                            </tr>
                            <tr>
                                <td style={{width:12,border:"none",textAlign:"end",paddingRight:2,paddingTop:0,paddingBottom:12}} ><i style={{paddingLeft:6,fontSize:"12pt"}} className="fa fa-map-marker" /></td>
                                <td style={{width:125,border:"none",paddingLeft:1,paddingTop:0,paddingBottom:0,fontSize:"8pt"}}>{this.props.officeaddress}</td>
                            </tr>
                            <tr>
                                <td style={{width:12,border:"none",textAlign:"end",paddingRight:2,paddingTop:0,paddingBottom:0}} ></td>
                                <td style={{width:125,border:"none",paddingLeft:1,paddingTop:0,paddingBottom:0,color:"red"}}><b>{this.props.URL}</b></td>
                            </tr>

                        </tbody>
                    </table>

                    </div>
{/*}            <aside>*/}
                    
            <div style={{textAlign:"left", paddingTop:0,backgroundColor:"#fff",height:"46mm",width:"28mm",marginTop:1,float:"left",background :"#fff"}}>
          {/*}  <img src={TitleLogo} alt="Logo" style={{width:102, height:70,paddingBottom:7,paddingRight:1,paddingLeft:8}} ></img>*/}
            <QRCode title="" value={this.state.VCard} bgColor="white" fgColor="black"  size="100" style={{marginTop:"7px",marginLeft:"5px",paddingBottom:"5px"}}/>
            </div>
{/*}            </aside>*/}

            </main>
            </div>
{/*}            <div style={{width:"105mm",textAlign:"end"}}>
            <button type="btn" style={{backgroundColor:"#fff",color:"blue",border:"none",marginTop:15,textAlign:"right"}} onClick={this.downloadImage}>Download</button>
 
        </div>*/}
{/*}            </div>*/}

            </Modal.Body>

            <Modal.Footer >
{/*}            <Button style={{marginLeft:"5px"}} variant="secondary" size="sm" onClick={this.downloadImage}>Download</Button>*/}
            <Button style={{marginRight:"5px"}} variant="secondary" size="sm" onClick={this.closeModal}>Close</Button>

        </Modal.Footer>
      </Modal>

)
}
}